import { c } from '../../../contract';
import { funnelFoxRouter } from './funnelfox.router';
import { retentionMessagingRouter } from './retention-messaging.router';
import { revenueCatRouter } from './revcat.router';
import { stripeRouter } from './stripe.router';
import { typeformRouter } from './typeform.router';

export const webhooksRouter = c.router(
  {
    typeform: typeformRouter,
    revenueCat: revenueCatRouter,
    stripe: stripeRouter,
    funnelFox: funnelFoxRouter,
    retentionMessaging: retentionMessagingRouter,
  },
  {
    pathPrefix: '/webhooks',
  },
);
